<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Reduction Of Manpower</div>
            <div class="col-auto"><span class="badge view" style="font-size: small;height: auto;">Balance:
                    {{Card.Balance}}</span></div>
            <div class="col-auto"><span class="badge view" style="font-size: small;height: auto;">Reduction:
                    {{Card.Reduction}}</span></div>
            <div class="col-auto"><span class="badge view" style="font-size: small;height: auto;">Different:
                    {{Card.Balance - Card.Reduction}}</span></div>
        </div>
    </div>
    <div class="card-body">
        <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
            <div class="row py-1">
                <div class="col-md-6">
                    <label class="Label">Site</label>
                    <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID" placeholder="Select Site"
                        [(ngModel)]="Filter.SiteID" name="Site" required disabled>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site.
                    </div>
                </div>
                <div class="col-md-4">
                    <label class="Label">Apply Date</label>
                    <div class="input-group" style="height: auto;">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ApplyDate"
                            [(ngModel)]="Card.ApplyDate" ngbDatepicker #ApplyDate="ngbDatepicker"
                            style="height: auto; font-size: small; padding: 0.2rem 0.4rem;" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ApplyDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-auto">
                    <button type="button" class="btn btn-primary mt-4" [disabled]="isDisabled" (click)="ApplyDates()">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply Date':'Loading...'}}
                    </button>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Designation</label>
                    <ng-select [items]="Designations" bindLabel="DesignationName" bindValue="DesignationMasterID"
                        placeholder="Select Designation" [(ngModel)]="Filter.DesignationID" name="Designation">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select designation.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Duty</label>
                    <ng-select [items]="Dutys" bindLabel="DutyName" bindValue="DutyMasterID" placeholder="Select Duty"
                        [(ngModel)]="Filter.DutyID" name="Duty">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select duty.
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Shift</label>
                    <ng-select [items]="Shifts" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="Select Shift" [(ngModel)]="Filter.ShiftID" name="Shift">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select shift.
                    </div>
                </div>
                <div class="col-md">
                    <label class="Label">Work Order No.</label>
                    <input type="text" class="form-control" id="WorkOrderNo" name="WorkOrderNo"
                        [(ngModel)]="Filter.WorkOrderNo" #WorkOrderNo="ngModel">
                </div>
                <div class="col-md-auto">
                    <button type="submit" class="btn btn-primary mt-4" [disabled]="isDisabled">
                        <i class="bi bi-download" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Load':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>

        <table datatable class="customeDatatable table table-bordered">
            <thead>
                <tr>
                    <th scope="col" style="width: 3px;">#</th>
                    <th scope="col">Entry No </th>
                    <th scope="col">Addition Date</th>
                    <th scope="col">Designation Name</th>
                    <th scope="col">Duty Name</th>
                    <th scope="col">Shift Name</th>
                    <th scope="col">WO No.</th>
                    <th scope="col">WO Dt.</th>
                    <th scope="col" style="width: 5px;">Balance </th>
                    <th scope="col">Reduction Count</th>
                    <th scope="col" style="width:180px">Reduction Date</th>
                    <th scope="col">Remarks</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of WorkOrders; let i = index">
                    <th scope="row" style="width: 3px;">{{ i + 1 }}</th>
                    <td>{{element.EntryNo}}</td>
                    <td>{{element.AdditionDate}}</td>
                    <td>{{element.DesignationName}}</td>
                    <td>{{element.DutyName}}</td>
                    <td>{{element.ShiftTitle}}</td>
                    <td>{{element.WONo}}</td>
                    <td>{{element.WODate}}</td>
                    <td class="text-end" style="width: 5px;">
                        <span class="no-of-person">{{element.Balance}}
                        </span>
                    </td>
                    <td>
                        <input type="text" pattern="^(?:[1-9]\d*|0)$" class="form-control text-end"
                            (keypress)="common.NumberOnly($event)" id="NoOfPerson{{i}}" name="NoOfPerson{{i}}"
                            [(ngModel)]="element.NoOfPerson" #NoOfPerson="ngModel" (change)="CalculateTotol()">
                        <div class="invalid-feedback">
                            Please enter no of person!
                        </div>
                    </td>
                    <td style="width:180px">
                        <div class="input-group" style="height: auto;" style="width:180px">
                            <input class="form-control" placeholder="DD MMM YYYY" name="FromDate{{i}}"
                                [(ngModel)]="element.FromDate" ngbDatepicker #FromDate="ngbDatepicker"
                                style="height: auto; font-size: small; padding: 0.2rem 0.4rem;" readonly
                                [required]="element.NoOfPerson > 0" />
                            <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                                type="button"></button>
                            <div class="invalid-feedback">
                                Please enter date!
                            </div>
                        </div>
                    </td>
                    <td>
                        <input name="radius" class="form-control" [(ngModel)]="element.Remarks" type="text"
                            style="text-align: right; " />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer" style="overflow: auto;">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-primary mx-1" [disabled]="isDisabled" (click)="Cancel()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>

                <button type="button" class="btn btn-sm btn-primary mx-1" [disabled]="isDisabled" (click)="Ok()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'OK':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>